export const parseDealCubeHistoryByLevel = <THistoryDetail, TItem, TKey extends string | number>(
  details: THistoryDetail[],
  getIds: (detail: THistoryDetail) => string[],
  getItems: (detail: THistoryDetail) => TItem[] | undefined,
  keyExtractor: (item: TItem) => TKey
): Map<string, Map<TKey, TItem>> => {
  const result = new Map<string, Map<TKey, TItem>>()

  details.forEach((detail) => {
    const validIds = getIds(detail).filter(Boolean)
    if (!validIds.length) return

    validIds.forEach((id) => {
      if (!result.has(id)) {
        result.set(id, new Map<TKey, TItem>())
      }

      const targetMap = result.get(id)!
      getItems(detail)?.forEach((item) => {
        targetMap.set(keyExtractor(item), item)
      })
    })
  })

  return result
}

export const getCompositeIds = <
  T extends {
    level: string | number
    approversByLevel?: Array<{ decisionReasonCode: string | null }>
  },
>(
  detail: T
): string[] =>
  (detail.approversByLevel ?? [])
    .map((approver) =>
      approver?.decisionReasonCode
        ? `${String(detail.level).trim()}-${approver.decisionReasonCode}`
        : null
    )
    .filter((id): id is string => id !== null)
